<template>
  <a-modal
    :title="title"
    :width="1780"
    :visible="visible"
    :footer="null"
    :ldata="data"
    @cancel="
      () => {
        $emit('cancel');
      }
    "
  >
    <a-spin :spinning="loading">
      <!-- <div id="lossChart" style="width: 90%; height: 200px"></div> -->
      <a-table
        :scroll="{ y: 800 }"
        :columns="columns"
        :data-source="data"
        :pagination="false"
      >
      </a-table>
    </a-spin>
  </a-modal>
</template>
  
  <script>
import pick from "lodash.pick";
import { requestUrl } from "@/utils/request_url";
export default {
  name: "TaskLog",
  props: {
    loading: {
      type: Boolean,
      default: () => false,
    },
    ldata: {
      type: Array,
      default: () => null,
    },
    title: {
      type: String,
      default: "新增",
    },
    visible: {
      type: Boolean,
      required: true,
    },
  },

  data() {
    return {
      headers: {},
      columns: [
        {
          dataIndex: "lr",
          key: "lr",
          title: "学习率",
        },
        {
          title: "轮数",
          dataIndex: "epoch",
          key: "epoch",
        },
        {
          title: "步数",
          dataIndex: "step",
          key: "step",
        },
        {
          title: "损失",
          key: "loss",
          dataIndex: "loss",
        },
        
        {
          title: "时间",
          key: "createTime",
          dataIndex: "createTime",
        },
      ],
      data: [],
      dom: null,
      xData: [],
      yData: [],
    };
  },
  created() {
    // this.$nextTick(() => {
    // })
  },
  watch: {
    ldata: function (newValue, oldValue) {
      this.data = newValue;
    },
  },
  computed: {},
  mounted() {
    // const self = this
    // this.$nextTick(() => {
    //   self.drawChart()
    // })
  },
  methods: {
    init() {},
    drawChart() {
      let myChart = this.$echarts.init(document.getElementById("lossChart"));
      let option = {
        xAxis: {
          type: "category",
          data: this.xData,
        },
        yAxis: {
          type: "value",
        },
        series: [
          {
            data: this.yData,
            type: "line",
          },
        ],
      };

      myChart.setOption(option);

      // 使用刚指定的配置项和数据显示图表。
    },
  },
};
</script>
  
  <style scoped>
.ant-table-body {
  overflow-y: auto !important;
}
</style>
  